import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLastIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 10,
	height: 8,
	viewBox: "0 0 10 8",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M0.94 0L0 0.94L3.05333 4L0 7.06L0.94 8L4.94 4L0.94 0Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M5.33331 0L4.39331 0.94L7.44664 4L4.39331 7.06L5.33331 8L9.33331 4L5.33331 0Z",
		fill: "currentColor"
	})]
});
export default SvgLastIcon;
